import { render, staticRenderFns } from "./article-repo.vue?vue&type=template&id=1479f6fb&"
import script from "./article-repo.vue?vue&type=script&lang=js&"
export * from "./article-repo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports